module.exports = __webpack_public_path__ + "img/activityListBanner1.dc2f88eb.png";